import { modalRenderer } from '~/modal/modalRendererRegistry';
import { ExportImageModalContainer } from './exportImageModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportImage: undefined;
  }
}
modalRenderer.register('ExportImage', ExportImageModalContainer);
